export default function initMobileMenu() {
  const opener = document.querySelector('.nav-opener');
  const body = document.body;
  const classActive = 'menu--opened';
  const isDesktop = window.matchMedia('(min-width: 1024px)');

  const mobileHolder = document.querySelector('.header .navs-holder');

  const mobielLinks = mobileHolder.querySelectorAll('a');

  opener.addEventListener('click', (e)=> {
    e.preventDefault();
    body.classList.toggle(classActive);
  });
  function setDelay() {
    mobielLinks.forEach((link, i)=> {
      link.style.setProperty('--delay-link', `${i* 0.1}s`);
    });
  }
  setDelay();

  window.addEventListener('resize', ()=> {
    if(isDesktop.matches ){
      if(body.classList.contains(classActive)) {
        body.classList.remove(classActive);
      }
      mobielLinks.forEach((link, i)=> {
        link.style.removeProperty('--delay-link');
      });
    } else {
      setDelay();
    }
  });
}